export namespace QueryParams {
    export const CurrentPage = 'page'
    export const CodVia = 'codigovia'
    export const Municipio = 'municipio'
    export const NombreVia = 'nombrevia'
    export const Provincia = 'provincia'
  }